export const articlesPart1 = [
  {
    id: "kapadokya-rehberi",
    title: "Kapadokya Seyahat Rehberi: Peri Bacalarından Yeraltı Şehirlere Kapsamlı Kılavuz",
    category: "Gezi Rehberi",
    author: "Elif Kaya",
    date: "2026-03-15",
    readTime: "18 dk",
    shortDesc: "Türkiye'nin en ikonik destinasyonunda balon turlarından yeraltı şehirlerine, butik kaya otellerinden gizli vadilere uzanan kapsamlı bir seyahat kılavuzu.",
    content: `Kapadokya, Türkiye'nin en ikonik destinasyonlarından biri olmasına rağmen, bölgeyi gerçekten keşfetmek için doğru bilgiye ihtiyaç duyarsınız. Milyonlarca yıl önce volkanik patlamalar ve erozyon sonucu oluşan bu eşsiz coğrafya, her yıl dünya genelinden milyonlarca ziyaretçiyi ağırlamaktadır.

## Kapadokya Nerede ve Nasıl Gidilir?

Kapadokya, Nevşehir iline bağlı Göreme, Ürgüp, Avanos ve Uçhisar kasabalarını kapsayan geniş bir bölgedir. Bölgeye ulaşmanın en pratik yolu Nevşehir Kapadokya Havalimanı veya Kayseri Erkilet Havalimanı'dır.

## Nerede Kalmalı?

Göreme, bölgenin merkezi ve en popüler kasabasıdır. Kaya oteller burada yoğunlaşır ve her bütçeye uygun seçenekler mevcuttur.

**Önerilen Kaya Oteller:**
- **Argos in Cappadocia (Ürgüp):** Tarihi bir köy içinde butik otel.
- **Museum Hotel (Ürgüp):** Antika koleksiyonuyla eşsiz bir deneyim.
- **Kelebek Hotel (Göreme):** Bütçe dostu, samimi atmosfer.

## Balon Turu: Bilmeniz Gereken Her Şey

Kapadokya'da balon turu, bölgenin en ikonik deneyimidir. Fiyatlar kişi başı 150-300 Euro arasında değişir.

## Mutlaka Görülmesi Gereken Vadiler

**Güvercinlik Vadisi:** Kaya güvercinliklerinin oyulduğu, bisiklet turları için ideal bir vadi.
**Kızılçukur Vadisi:** Kırmızı kaya oluşumları ve bağ bahçeleriyle gün batımı için mükemmel.
**Ihlara Vadisi:** 14 km uzunluğundaki bu vadi, kaya kiliseleri ve Melendiz Çayı ile trekking tutkunları için cennet.

## Yeraltı Şehirleri

**Derinkuyu:** 85 metre derinliğe inen ve 20.000 kişiyi barındırabilecek kapasitedeki bu yeraltı şehri.
**Kaymaklı:** Derinkuyu'ya göre daha az derin ama daha geniş bir yeraltı şehridir.

## Pratik Bilgiler

**En İyi Zaman:** Nisan-Haziran ve Eylül-Kasım ayları hem hava hem de kalabalık açısından idealdir.`,
    image: "https://readdy.ai/api/search-image?query=Cappadocia%20Turkey%20travel%20guide%20hot%20air%20balloons%20sunrise%20valleys%20fairy%20chimneys%20golden%20hour%20aerial%20view&width=800&height=450&seq=art1&orientation=landscape",
    tags: ["Kapadokya", "Gezi Rehberi", "Balon Turu", "Konaklama"],
    featured: true,
  },
  {
    id: "pamukkale-efes-rehberi",
    title: "Pamukkale ve Efes Rehberi: Ege'nin İki UNESCO Mirası İçin Eksiksiz Kılavuz",
    category: "Gezi Rehberi",
    author: "Selin Arslan",
    date: "2026-03-28",
    readTime: "20 dk",
    shortDesc: "Kalsiyum beyazı travertenlerden antik Roma'nın görkemli kalıntılarına — Pamukkale ve Efes'i en verimli şekilde nasıl gezeceğinizi anlatan kapsamlı bir seyahat kılavuzu.",
    content: `Türkiye'nin Ege bölgesi, dünyanın en zengin arkeolojik ve doğal mirasına ev sahipliği yapmaktadır.

## Pamukkale: Pamuk Kale'nin Büyüsü

Pamukkale, Denizli iline bağlı ve "Pamuk Kale" anlamına gelen, binlerce yıldır akan kalsiyum karbonat açısından zengin termal suların oluşturduğu beyaz travertenlerle dünyanın en eşsiz doğal oluşumlarından biridir.

## Efes: Antik Dünyanın En Büyük Şehri

Efes, MÖ 10. yüzyılda kurulan ve Roma döneminde Anadolu'nun en büyük ve en önemli şehri olan antik bir kenttir.

**Celsus Kütüphanesi:** Efes'in simgesi haline gelen Celsus Kütüphanesi, MS 117-120 yılları arasında inşa edilmiştir.

**Büyük Tiyatro:** 25.000 kişilik kapasitesiyle antik dünyanın en büyük tiyatrolarından biri.

## Pratik Bilgiler

**En İyi Zaman:** Her iki destinasyon için de Nisan-Mayıs ve Eylül-Ekim ayları idealdir.`,
    image: "https://readdy.ai/api/search-image?query=Pamukkale%20white%20travertines%20Ephesus%20ancient%20ruins%20Turkey%20Aegean%20travel%20guide%20collage%20UNESCO%20heritage&width=800&height=450&seq=art-pam-efe&orientation=landscape",
    tags: ["Pamukkale", "Efes", "Gezi Rehberi", "UNESCO"],
    featured: true,
  },
  {
    id: "turkiye-underrated-yerler",
    title: "Türkiye'nin 15 Keşfedilmemiş Destinasyonu: Kalabalıktan Uzakta Gerçek Türkiye",
    category: "Keşif",
    author: "Mert Demir",
    date: "2026-02-28",
    readTime: "16 dk",
    shortDesc: "Popüler turizm rotalarının gölgesinde kalan, yerel halkın sırrını sakladığı ve özgün Türkiye deneyimini sunan 15 destinasyon.",
    content: `Türkiye, İstanbul ve Kapadokya'nın çok ötesinde, henüz kalabalık turist gruplarının uğramadığı onlarca muhteşem destinasyona ev sahipliği yapar.

## 1. Halfeti, Şanlıurfa

Fırat Nehri'nin Birecik Barajı'nın suları altında kalan eski köyünün üzerine kurulu Halfeti, Türkiye'nin en romantik ve melankolik kasabalarından biridir.

## 2. Uzungöl, Trabzon

Karadeniz'in saklı gölü. Sabah sisi ve çevreleyen ormanlarla fotoğraf tutkunlarının cenneti.

## 3. Taraklı, Sakarya

Osmanlı konakları ve ahşap mimarisiyle Safranbolu'nun daha sakin ve daha az bilinen alternatifi.

## 4. Yusufeli, Artvin

Çoruh Nehri kanyonları ve rafting rotalarıyla macera tutkunları için ideal.

## 5. Bozcaada

Ege'nin en küçük ve en şirin adası. Bağ bahçeleri, Rum evleri ve sakin plajlarıyla.

## 6. Divriği, Sivas

UNESCO listesindeki Ulu Cami ve Darüşşifası ile Türkiye'nin en az ziyaret edilen UNESCO mirası.

## 7. Hasankeyf, Batman

Tigris Nehri kıyısında, binlerce yıllık tarihi olan antik şehir.

## 8. Kars ve Ani Harabeleri

Ani Harabeleri, 10-11. yüzyıllarda Ermeni Bagratid Krallığı'nın başkenti.

## 9. Şavşat, Artvin

Artvin'in en yeşil ilçesi — şelaleler, göller ve el değmemiş doğasıyla.

## 10. Tire, İzmir

Her Salı kurulan tarihi pazarı ve Ege'nin en otantik köy atmosferiyle.

## 11. Amasya

Yeşilırmak kıyısında, kaya mezarları ve Osmanlı konakları arasında sıkışmış büyülü bir şehir.

## 12. Göbeklitepe, Şanlıurfa

12.000 yıllık tarihi ile dünyanın bilinen en eski tapınağı.

## 13. Nemrut Dağı, Adıyaman

2150 metre yükseklikte, devasa tanrı heykellerinin gün doğumunu beklediği UNESCO Dünya Mirası.

## 14. Gökçeada

Türkiye'nin en büyük adası, Bozcaada'nın daha az bilinen kardeşi.

## 15. Hatay (Antakya)

Türkiye'nin en çok kültür barındıran şehri.`,
    image: "https://readdy.ai/api/search-image?query=Turkey%20hidden%20gems%20underrated%20destinations%20collage%20Halfeti%20Uzungol%20Bozcaada%20scenic%20landscapes%20travel%20discovery&width=800&height=450&seq=art2&orientation=landscape",
    tags: ["Underrated", "Keşif", "Gizli Cennetler", "Türkiye"],
    featured: true,
  },
  {
    id: "gaziantep-gastronomi",
    title: "Gaziantep Gastronomi Rehberi: UNESCO Mutfak Şehrinde Bir Haftalık Lezzet Yolculuğu",
    category: "Gastronomi",
    author: "Selin Arslan",
    date: "2026-01-20",
    readTime: "17 dk",
    shortDesc: "UNESCO Yaratıcı Şehirler Ağı'nın gastronomi üyesi Gaziantep'te sabah katmerinden gece baklavasına uzanan kapsamlı bir yeme-içme rehberi.",
    content: `Gaziantep, UNESCO tarafından gastronomi şehri olarak tescillenen, Türkiye'nin yemek kültürü açısından en zengin şehridir.

## Gaziantep Mutfağının Tarihi ve Önemi

Gaziantep mutfağı, Orta Doğu, Akdeniz ve Anadolu mutfaklarının kesişim noktasında gelişmiş, binlerce yıllık bir kültürel birikimin ürünüdür.

## Sabah: Katmer ve Beyran

**Katmer:** Gaziantep'e özgü ve sabahın erken saatlerinde, taş fırında pişirilen, içi fıstıklı ve kaymakla dolu bir hamur işidir.

**Beyran Çorbası:** Kuzu eti, pirinç ve sarımsakla hazırlanan beyran çorbası, Gaziantep'e özgü ve sabah 6'dan itibaren servis edilen bir çorbadır.

## Öğle Yemeği: Kebap Kültürü

**Fıstıklı Kebap:** Antep fıstığıyla hazırlanan bu kebap türü yalnızca Gaziantep'te bulunur.

**Ali Nazik:** Közlenmiş patlıcan üzerine yoğurt ve kuzu eti.

## Tatlı: Baklava Kültürü

Gaziantep baklavası dünyaca ünlüdür. Fıstıklı Baklava, Sütlü Nuriye, Kuru Baklava çeşitleri mevcuttur.

**En İyi Baklava Adresleri:**
- İmam Çağdaş
- Koçak Baklava
- Güllüoğlu`,
    image: "https://readdy.ai/api/search-image?query=Gaziantep%20Turkish%20food%20spread%20baklava%20kebab%20pistachio%20traditional%20cuisine%20gastronomy%20city%20colorful%20dishes&width=800&height=450&seq=art3&orientation=landscape",
    tags: ["Gaziantep", "Gastronomi", "Baklava", "Kebap"],
    featured: true,
  },
  {
    id: "nemrut-gobeklitepe-rehberi",
    title: "Nemrut Dağı ve Göbeklitepe: Güneydoğu Anadolu'nun İki Arkeolojik Şaheseri",
    category: "Tarih & Arkeoloji",
    author: "Ahmet Yıldız",
    date: "2026-02-10",
    readTime: "15 dk",
    shortDesc: "İnsanlık tarihini yeniden yazan 12.000 yıllık Göbeklitepe'den Kommagene Krallığı'nın açık hava tapınağı Nemrut'a kapsamlı rehber.",
    content: `Güneydoğu Anadolu, insanlık tarihinin en önemli arkeolojik keşiflerine ev sahipliği yapmaktadır.

## Göbeklitepe: İnsanlık Tarihini Yeniden Yazan Keşif

Göbeklitepe, MÖ 10.000 yılına tarihlenen ve dünyanın bilinen en eski tapınak kompleksi olma özelliğini taşıyan olağanüstü bir arkeolojik alandır.

## Nemrut Dağı: Tanrıların Tahtı

Nemrut Dağı, MÖ 1. yüzyılda Kommagene Krallığı'nın hükümdarı I. Antiokhos tarafından inşa ettirilen ve 2150 metre yükseklikte yer alan muhteşem bir açık hava tapınağıdır.

**Gün Doğumu Deneyimi:** Heykel başlarının güneşin ilk ışıklarıyla aydınlandığı o an, unutulmaz bir görüntü sunar.

## Pratik Bilgiler

**En İyi Zaman:** Her iki destinasyon için de Mayıs-Ekim ayları idealdir.`,
    image: "https://readdy.ai/api/search-image?query=Gobeklitepe%20ancient%20stone%20pillars%20Nemrut%20Mountain%20statues%20Turkey%20archaeological%20heritage%20collage%20history&width=800&height=450&seq=art-nem-gob&orientation=landscape",
    tags: ["Nemrut", "Göbeklitepe", "Arkeoloji", "Tarih"],
    featured: true,
  },
  {
    id: "karadeniz-yaylalari",
    title: "Karadeniz Yaylaları Rehberi: Ayder'den Pokut'a Doğanın Kalbinde Seyahat",
    category: "Doğa",
    author: "Ahmet Yıldız",
    date: "2025-12-10",
    readTime: "14 dk",
    shortDesc: "Kaçkar Dağları'nın eteklerinden Trabzon'un sisli yaylalarına uzanan bu rehberde Ayder, Pokut, Sal ve Elevit yaylalarını keşfediyoruz.",
    content: `Karadeniz yaylaları, Türkiye'nin en az keşfedilmiş doğal hazineleri arasındadır.

## Ayder Yaylası: Karadeniz'in Başkenti

Ayder Yaylası, Rize'nin Çamlıhemşin ilçesinde, Kaçkar Dağları'nın eteklerinde, 1350 metre yükseklikte yer alır.

**Termal Tesisler:** Ayder'in en önemli özelliklerinden biri termal sularıdır.

**Kaçkar Trekking:** Ayder, Kaçkar Dağları'na yapılan trekking turlarının başlangıç noktasıdır.

## Pokut Yaylası: Ayder'in Sakin Kardeşi

Pokut Yaylası, Ayder'in 10 km uzağında, daha sakin ve el değmemiş bir yayla.

## Karadeniz Mutfağı

- **Muhlama:** Mısır unu ve peynirle yapılan geleneksel yemek.
- **Karalahana Çorbası:** Kara lahana, mısır unu ve tereyağıyla hazırlanan çorba.
- **Hamsi:** Karadeniz'in simgesi.

## Pratik Bilgiler

**En İyi Zaman:** Haziran-Eylül ayları en ideal dönemdir.`,
    image: "https://readdy.ai/api/search-image?query=Black%20Sea%20Turkey%20yayla%20plateau%20green%20mountains%20wooden%20houses%20misty%20clouds%20Karadeniz%20nature%20landscape%20summer&width=800&height=450&seq=art4&orientation=landscape",
    tags: ["Karadeniz", "Yayla", "Doğa", "Trekking"],
    featured: false,
  },
  {
    id: "istanbul-gizli-noktalar",
    title: "İstanbul'un Gizli Kalmış 20 Noktası: Yerel Halkın Rotasında Şehri Keşfetmek",
    category: "Şehir Rehberi",
    author: "Zeynep Çelik",
    date: "2025-11-05",
    readTime: "16 dk",
    shortDesc: "Ayasofya ve Kapalıçarşı'nın çok ötesinde — İstanbul'un yerel halkın bildiği ama turist kalabalıklarının henüz keşfedemediği semtleri.",
    content: `İstanbul, milyonlarca turistin ziyaret ettiği bir şehir olmasına rağmen, hâlâ keşfedilmeyi bekleyen onlarca gizli köşeye sahiptir.

## Tarihi Yarımada'nın Gizli Köşeleri

### 1. Balat

Fener'in hemen yanı başında, renkli Rum ve Yahudi evleriyle dolu tarihi semt.

### 2. Kuzguncuk

Boğaz'ın Anadolu yakasında, ahşap evleri ve sakin atmosferiyle İstanbul'un en sevimli semtlerinden biri.

### 3. Arnavutköy

Boğaz kıyısında, ahşap yalıları ve balık restoranlarıyla İstanbul'un en romantik semtlerinden biri.

### 4. Bebek

Boğaz'ın en şık semtlerinden biri olan Bebek, sahil boyunca uzanan kafeler ve yat limanıyla.

### 5. Kadıköy Çarşısı

Anadolu yakasının en canlı çarşısı olan Kadıköy, taze sebze-meyve, balık, peynir ve şarküteri ürünleriyle dolu bir gastronomi cenneti.

## Pratik Bilgiler

**En İyi Zaman:** Nisan-Mayıs ve Eylül-Ekim ayları hem hava hem de kalabalık açısından idealdir.`,
    image: "https://readdy.ai/api/search-image?query=Istanbul%20hidden%20gems%20Balat%20colorful%20houses%20Bosphorus%20local%20neighborhood%20authentic%20Turkish%20city%20life%20streets&width=800&height=450&seq=art5&orientation=landscape",
    tags: ["İstanbul", "Şehir Rehberi", "Gizli Noktalar", "Yerel"],
    featured: false,
  },
  {
    id: "ege-adaları-rehberi",
    title: "Bozcaada ve Gökçeada Rehberi: Türkiye'nin İki Saklı Ege Adasında Tam Kılavuz",
    category: "Ada & Deniz",
    author: "Can Öztürk",
    date: "2025-10-18",
    readTime: "14 dk",
    shortDesc: "Bağ bahçeleri ve Rum mimarisiyle büyüleyen Bozcaada ile terk edilmiş köyleri ve berrak dalış noktalarıyla öne çıkan Gökçeada rehberi.",
    content: `Türkiye'nin Ege kıyısında iki küçük ama büyülü ada bulunur: Bozcaada ve Gökçeada.

## Bozcaada: Ege'nin Şarap Adası

Türkiye'nin en küçük ilçelerinden biri olan Bozcaada, bağ bahçeleri, Rum evleri ve sakin plajlarıyla Ege'nin en şirin adasıdır.

**Şarap Kültürü:** Bozcaada'nın bağları, Türkiye'nin en kaliteli şaraplarını üretmektedir.

**Ziyaret Edilmesi Gereken Şaraphaneler:**
- Corvus Winery
- Amadeus Winery

## Gökçeada: Türkiye'nin En Büyük Adası

Türkiye'nin en büyük adası olan Gökçeada, Bozcaada'ya göre daha az ziyaretçi çeker ve bu sayede daha otantik bir deneyim sunar.

**Zeytinli Köyü:** Gökçeada'nın en etkileyici noktalarından biri, terk edilmiş Rum evleriyle dolu Zeytinli Köyü'dür.

## Pratik Bilgiler

**En İyi Zaman:** Her iki destinasyon için de Mayıs-Ekim ayları idealdir.`,
    image: "https://readdy.ai/api/search-image?query=Bozcaada%20Gokceada%20Turkey%20Aegean%20island%20vineyard%20Greek%20architecture%20white%20houses%20blue%20sea%20summer&width=800&height=450&seq=art6&orientation=landscape",
    tags: ["Ege", "Ada", "Bozcaada", "Gökçeada"],
    featured: false,
  },
  {
    id: "istanbul-gezilecek-yerler",
    title: "İstanbul'da Gezilecek 50 Yer: Tarihi Yarımadadan Boğaz'a Kapsamlı Şehir Rehberi",
    category: "Şehir Rehberi",
    author: "Ayşe Yılmaz",
    date: "2026-04-10",
    readTime: "25 dk",
    shortDesc: "Bizans ve Osmanlı mirasından Boğaz'ın en şık semtlerine uzanan İstanbul'un en kapsamlı gezi rehberi — 50 durak, 50 farklı deneyim.",
    content: `İstanbul'da gezilecek yerler saymakla bitmez. Asya ve Avrupa'yı birbirine bağlayan, binlerce yıllık tarihiyle dünyanın en büyüleyici şehirlerinden biri olan İstanbul, her köşesinde farklı bir sürpriz barındırır.

## Tarihi Yarımada'da Gezilecek Yerler

**1. Ayasofya-i Kebir Cami-i Şerifi:** 537 yılında kilise olarak inşa edilen, dünya mimarlık tarihinin başyapıtlarından biridir.

**2. Sultanahmet Camii (Blue Mosque):** İznik çinileriyle bezenmiş iç mekanı ve altı minaresiyle İstanbul silüetinin en ikonik parçasıdır.

**3. Topkapı Sarayı:** Osmanlı İmparatorluğu'nun 400 yıl boyunca idare merkezi.

**4. Yerebatan Sarnıcı:** 336 sütunu ve Medusa başlarıyla mistik bir yeraltı su sarnıcı.

**5. Kapalıçarşı:** Dünyanın en eski ve en büyük kapalı çarşılarından biri.

## Boğaz ve Çevresi

**11. Dolmabahçe Sarayı:** Osmanlı'nın son dönemine tanıklık eden muazzam saray.

**12. Ortaköy Meydanı ve Camii:** Kumpir yiyip Boğaz köprüsü manzarasına karşı fotoğraf çektirmek İstanbul ritüellerindendir.

## Anadolu Yakası

**26. Kız Kulesi:** Salacak açıklarında denizin ortasında yer alan, efsanelere konu olmuş kule.

**27. Kadıköy Çarşısı ve Moda:** Tarihi çarşısında alışveriş yapıp Moda sahilinde yürüyüş yapmak Anadolu yakasının klasiğidir.

## Adalar

**41. Büyükada:** Adaların en büyüğü. Aya Yorgi Kilisesi'ne tırmanmak şarttır.`,
    image: "https://readdy.ai/api/search-image?query=Istanbul%20Bosphorus%20view%20Hagia%20Sophia%20Blue%20Mosque%20Galata%20Tower%20city%20skyline%20sunset%20Turkey&width=800&height=450&seq=art-ist-50&orientation=landscape",
    tags: ["İstanbul", "Gezilecek Yerler", "Şehir Rehberi", "Marmara"],
    featured: true,
  },
  {
    id: "sakarya-gezilecek-yerler",
    title: "Sakarya Gezi Rehberi: Sapanca Gölü'nden Longoz Ormanlarına 20 Doğa ve Tarih Rotası",
    category: "Gezi Rehberi",
    author: "Emre Can",
    date: "2026-04-09",
    readTime: "12 dk",
    shortDesc: "İstanbul'a iki saatlik mesafede, Sapanca Gölü kıyılarından Acarlar Longozu'na, Osmanlı konakları barındıran Taraklı'dan Karadeniz sahillerine uzanan Sakarya'nın en güzel 20 rotası.",
    content: `İstanbul ve Ankara'ya yakınlığı, yemyeşil doğası, gölleri, longoz ormanları ve tarihi evleriyle Sakarya, hafta sonu kaçamaklarının vazgeçilmez adresidir.

## Göller ve Longoz Ormanları

**1. Sapanca Gölü ve Sahili:** Sakarya denilince akla ilk gelen yerdir.

**2. Acarlar Longozu (Su Basar Ormanı):** Türkiye'nin tek parça halindeki en büyük longoz ormanıdır.

**3. Poyrazlar Gölü Tabiat Parkı:** Özellikle ilkbahar ve sonbaharda piknik için ideal.

## Tarihi ve Kültürel Noktalar

**5. Taraklı Evleri ve Tarihi Çarşısı:** UNESCO Dünya Mirası Geçici Listesi'nde yer alan Taraklı.

**6. Justinianus Köprüsü (Beşköprü):** Bizans İmparatoru Justinianus tarafından MS 558-560 yıllarında yaptırılan tarihi köprü.

## Karadeniz Sahilleri

**15. Karasu Sahili ve Plajı:** Türkiye'nin en uzun kumsallarından birine sahip Karasu.

Sakarya; İstanbul'un kalabalığından bir saatte kaçıp, göl kenarında kahvaltı yapabileceğiniz muhteşem bir doğa şehridir.`,
    image: "https://readdy.ai/api/search-image?query=Sapanca%20lake%20Sakarya%20nature%20Acarlar%20Longozu%20forest%20Turkey%20landscape%20weekend%20getaway&width=800&height=450&seq=art-sak-20&orientation=landscape",
    tags: ["Sakarya", "Sapanca", "Gezi Rehberi", "Marmara"],
    featured: false,
  },
];
